module.exports = __webpack_public_path__ + "img/footer-email-icon.5a90ac4a.svg";